import React from 'react';
import styled from 'styled-components';

function DisclaimerSection() {
  return (
    <Container>
      <Text>
        ・본 서비스에서 제공하는 경매물건 정보는 대법원 경매자료 및 기타
        공부서류를 기초로 제공되며, 입력 착오 또는 내용 변경 등으로 실제와 다를
        수 있습니다.
      </Text>
      <Text>
        ・입찰 참여 전 반드시 해당 법원에 비치된 매각물건명세서, 현황조사서 등
        관련 자료를 직접 열람하시어 정보를 재확인하시기 바랍니다.
      </Text>
      <Text>
        ・본 정보는 참고용으로 제공되며, 이를 기반으로 한 입찰 등 행위로
        발생하는 손해에 대해 당사는 법적 책임을 지지 않습니다.
      </Text>
    </Container>
  );
}

export default DisclaimerSection;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 16px;
  gap: 8px;
  background-color: #70737c0d;
`;

const Text = styled.div`
  font-weight: 500;
  font-size: 12px;
  color: #37383c9c;
`;
